import { isoDate } from '@/hooks/useUrlState';

/** Last Monday to Sunday, the period the report opens on (not written to the URL). */
export function defaultConsumptionRange(): { from: string; to: string } {
  const today = new Date();
  const lastMonday = new Date(today);
  lastMonday.setDate(today.getDate() - today.getDay() - 6);
  const lastSunday = new Date(lastMonday);
  lastSunday.setDate(lastMonday.getDate() + 6);

  return {
    from: lastMonday.toISOString().slice(0, 10),
    to: lastSunday.toISOString().slice(0, 10),
  };
}

/** The /consumption-report query string (see README "List pages, URL state"). */
export const consumptionReportUrlSchema = {
  from: isoDate(() => defaultConsumptionRange().from),
  to: isoDate(() => defaultConsumptionRange().to),
};
